import { CURRENT_ENV, OG_TITLE } from 'components_v2/common'
import { useEffect, useMemo } from 'react'

const setMeta = (attr, value, content) => {
  let el = document.querySelector(`meta[${attr}="${value}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, value)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}
export const flattenMeta = (obj, prefix = '') => {
  return Object.entries(obj).flatMap(([key, value]) => {
    const prop = prefix ? `${prefix}:${key}` : key

    if (Array.isArray(value)) {
      return value.flatMap((item) =>
        typeof item === 'object'
          ? flattenMeta(item, prop)
          : [{ property: prop, content: String(item) }]
      )
    }

    if (typeof value === 'object' && value !== null) {
      return flattenMeta(value, prop)
    }

    const content = String(value ?? '')
    return key === '_'
      ? [{ property: prefix, content }]
      : [{ property: prop, content }]
  })
}

const setRel = (content) => {
  let el = document.querySelector(`link[rel="canonical"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', content)
}

const removeMeta = (type = 'meta', attr, value) => {
  document.querySelector(`${type}[${attr}="${value}"]`)?.remove()
}

export const useTitle = (title) => {
  useEffect(() => {
    if (title) {
      const fullTitle = String(title)
        .toLowerCase()
        ?.includes('alo wellness club')
        ? title
        : `${title} | ALO Wellness Club`
      setMeta('property', 'og:title', title)
      document.title = `${CURRENT_ENV}${fullTitle}`
    }
    return () => {
      removeMeta('meta', 'property', 'og:title')
      document.title = `${CURRENT_ENV}${OG_TITLE}`
    }
  }, [title])
}

export const useMeta = (meta = []) => {
  const updatedMeta = useMemo(
    () =>
      meta.flatMap((item) =>
        item?.name === 'description'
          ? [{ ...item, property: 'og:description' }, item]
          : [item]
      ),
    [meta]
  )

  useEffect(() => {
    updatedMeta.forEach(({ name, property, content, canonical }) => {
      if (canonical) {
        const value =
          typeof canonical === 'string'
            ? canonical
            : `${window.location.origin}${window.location.pathname}`
        setRel(value)
      } else {
        const attr = property ? 'property' : 'name'
        content && setMeta(attr, property || name, content)
      }
    })

    return () => {
      updatedMeta.forEach(({ name, property, canonical = '' }) => {
        if (canonical) {
          removeMeta('link', 'rel', 'canonical')
        } else {
          const attr = property ? 'property' : 'name'
          removeMeta('meta', attr, property || name)
        }
      })
    }
  }, [updatedMeta])
}
